<template>
  <div class='add-class'>
    <!-- 新增约课弹窗 -->
    <el-dialog v-model="dialogVisible" title="新增约课" width="1000px" @close="onClose">
        <el-form :model="form" ref="formRef" label-width="120px" :rules="formRules">
            <el-form-item label="家长" prop="record.parentId" :rules="[{ required: true, message: '请选择家长' }]">
                <el-select v-model="form.record.parentId" placeholder="请选择家长" filterable style="width: 240px">
                    <el-option v-for="item in parentList" :key="item.userId" :label="item.realName" :value="item.userId" />
                </el-select>
            </el-form-item>

            <el-form-item label="老师" prop="record.teacherId" :rules="[{ required: true, message: '请选择老师' }]">
                <el-select v-model="form.record.teacherId" placeholder="请选择老师" @change="handleTeacherChange" filterable style="width: 240px">
                    <el-option v-for="item in teacherList" :key="item.userId" :label="item.realName" :value="item.userId" />
                </el-select>
            </el-form-item>

            <el-form-item label="教学科目" prop="record.projectObj" :rules="[{ required: true, message: '请选择教学科目' }]">
                <el-cascader
                    v-model="form.record.projectObj"
                    :props="projectProps"
                    :options="projectList"
                    @change="handleChange"
                />
            </el-form-item>

            <el-form-item label="预约日期" prop="timeList" :rules="[{ required: true, message: '请选择日期' }]">
                <el-select v-model="form.timeList" multiple placeholder="请选择日期" style="width: 240px">
                  <el-option v-for="item in timeList" :key="item.objId" :label="item.label" :value="item.objId" />
                </el-select>
            </el-form-item>

            <el-form-item label="上课校区" prop="record.campus"  :rules="[{ required: true, message: '请选择上课校区' }]">
                <el-select v-model="form.record.campus" placeholder="请选择上课校区" style="width: 540px">
                    <el-option v-for="item in areaRoomList" :key="item.id" :label="item.label" :value="item.id" />
                </el-select>
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button @click="handleCancel">取消</el-button>
            <el-button type="primary" @click="handleConfirm(formRef)" :loading="submitLoading">确认</el-button>
        </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { reactive, ref, watchEffect, computed } from 'vue'
import { fetchGetParentList, getTeacherList, fetchGetProject, getAppointmentTime, fetchGetAppClassRoomList, fetchSubmitClass } from '@/service/main/system/system'
import { ElMessage } from 'element-plus'

const props = defineProps(['show'])
const emit = defineEmits(['onClose'])
const form = reactive({
  record: {
    teacherId: '', //老师ID
    parentId: '', //家长ID
    type: 1,
    courseType: 1,
    campus: '',
    projectObj: []
  },
  timeList: [],
})

const projectProps = {
    label: 'label',
    value: 'value',
    children: 'children'
}
const formRef = ref()
const parentList = ref([]) // 家长列表
const teacherList = ref([]) // 老师列表
const timeList = ref([]) // 预约时间
const areaRoomList = ref([]) // 校区列表
const projectList = ref([]) // 获取科目列表
const dialogVisible = ref(false)

watchEffect(() => {
    dialogVisible.value = props.show

    if(dialogVisible.value) {
        getParentList()
        fetchTeacherList()
        getAppClassRoomList()
    }
})

const getProjectObj = computed(() => {
    if(projectList.value?.length && form.record.projectObj?.length) {
        let obj = {}
        const levelObj = projectList.value?.find(item => item.value == form.record.projectObj[0]) || {}
        const gradeObj = levelObj?.children?.find(item => item.value == form.record.projectObj[1]) || {}
        const projectObj = gradeObj?.children?.find(item => item.value == form.record.projectObj[2]) || {}
        console.log(levelObj, gradeObj, projectObj)
        return { 
            levelKey: levelObj?.value, //年级科目信息
            levelName: levelObj?.label, //年级科目信息
            gradeKey: gradeObj?.value, //年级科目信息
            gradeName: gradeObj?.label, //年级科目信息
            subjectKey: projectObj?.value, //年级科目信息
            subjectValue: projectObj?.label, //年级科目信息 
        }
    }
    return {}
})

// 获取家长列表
let getParentList = async () => {
  const res = await fetchGetParentList()
  parentList.value = res?.data || []
}

// 获取教师列表
const fetchTeacherList = async () => {
  const res = await getTeacherList('/pc/userInfo/teacherDropDown')
  teacherList.value = res?.data || []
}

const handleCancel = () => {
  onClose()
}

// 获取时间链
const fetchTimeList = async () => {
    if (!form.record.teacherId) return
    const res = await getAppointmentTime('/pc/userInfo/timeDropDown', { userId: form.record.teacherId })
    timeList.value = res?.data.map((item) => ({
        label: `${item.appointmentDate} - ${item.appointmentTimeValue}`,
        ...item
    })).filter((item) => item.isAppointment === 1)
    console.log(timeList.value)
}

// 获取教学科目
const getProject = async () => {
    if (!form.record.teacherId) return

    const res = await fetchGetProject(form.record.teacherId)
    projectList.value = convertDataToCascader(res.data)
}

/**
 * 递归转换函数 - 针对你的特定数据结构
 * @param {Array} data - 原始数据
 * @param {number} level - 当前层级（0:学段, 1:年级, 2:科目）
 * @returns {Array} 转换后的级联数据
 */
 function convertDataToCascader(data, level = 0) {
  // 边界条件：如果数据为空或不是数组，返回空数组
  if (!data || !Array.isArray(data)) {
    return []
  }
  
  return data.map(item => {
    // 根据层级确定使用哪个字段名
    let labelField, valueField, childrenField
    
    switch (level) {
      case 0: // 第一层：学段
        labelField = 'levelName'
        valueField = 'levelKey'
        childrenField = 'list'
        break
      case 1: // 第二层：年级
        labelField = 'gradeName'
        valueField = 'gradeKey'
        childrenField = 'list'
        break
      case 2: // 第三层：科目
        labelField = 'subjectName'
        valueField = 'subjectKey'
        childrenField = null // 科目层没有子级
        break
      default: // 其他层级（如果有）
        labelField = 'name'
        valueField = 'key'
        childrenField = 'list'
    }
    
    // 创建节点
    const node = {
      label: item[labelField] || '',
      value: item[valueField] || ''
    }
    
    // 如果有子节点且需要递归处理
    if (childrenField && item[childrenField] && Array.isArray(item[childrenField])) {
      node.children = convertDataToCascader(item[childrenField], level + 1)
      
      // 如果子节点为空数组，可以删除 children 属性（可选）
      if (node.children.length === 0) {
        delete node.children
      }
    }
    
    return node
  })
}

// 上课校区
const getAppClassRoomList = async () => {
    const res = await fetchGetAppClassRoomList()
    areaRoomList.value = res.data.map(item => {
        return {
            ...item,
            label: item.locationProvince + item.locationCity + item.locationCounty + item.name
        }
    }) || [];
}

const handleTeacherChange = (val) => {
    timeList.value = []
    form.timeList = []
    form.record.projectObj = []
    getProject()
    fetchTimeList()
}

const handleConfirm = async (formEl) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
        console.log(timeList.value, form.timeList)
        let times = timeList.value.filter(item => {
            return form.timeList.includes(item.objId)
        }).map(item => {
            return {
                objId: item.objId, //预约时间下拉的objId
                appointmentTimeKey: item.appointmentTimeKey, //预约时间下拉的appointmentTimeKey
                appointmentTimeValue: item.appointmentTimeValue, //预约时间下拉的appointmentTimeValue
                appointmentDate: item.appointmentDate //预约时间下拉的appointmentDate
            }
          })
          
          try {
            const res = fetchSubmitClass({
              record: {
                ...form.record,
                ...getProjectObj.value
              },
              timeList: times
            })
            ElMessage({
              type: 'success',
              message: '约课成功',
            })
            onClose(true)
          } catch (error) {
            // console.log(error)
          }
    } else {
      console.log('error submit!', fields)
    }
  })
}

const onClose = (e) => {
    emit('onClose', e || false)
}

</script>


<style scoped lang='less'>

</style>